import LoginForm from "../components/LoginForm";
import { useAuth } from "@features/auth/contexts/AuthContext";
import { Navigate } from "react-router-dom";
import AuthLayout from "@shared/layouts/AuthLayout";
import ThreeDotLoader from "@shared/components/ThreeDotLoader";

const LoginPage = () => {
  const auth = useAuth();

  if (auth.isLoading) {
    return (
      <div className="h-svh flex items-center justify-center">
        <ThreeDotLoader />
      </div>
    );
  }

  if (auth.user) {
    return <Navigate to="/" replace={true} />;
  }

  return (
    <>
      <AuthLayout>
        <LoginForm />
      </AuthLayout>
    </>
  );
};

export default LoginPage;
